module.exports = __webpack_public_path__ + "img/Right.f7513d44.svg";